import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=6cfc797f&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=6cfc797f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc797f",
  null
  
)

export default component.exports